export const fr = {
  app: {
    name: 'mycount',
    tagline: 'Attends, laisse-moi vérifier quelque chose',
    install: 'Installer l\'application',
    downloading: 'Téléchargement',
    installing: 'Installation',
    downloadComplete: 'Installation terminée',
    downloadRetrying: 'Connexion perdue, nouvelle tentative...',
    downloadFailed: 'Échec du téléchargement. Veuillez réessayer plus tard.',
    offlineReady: 'Application prête pour une utilisation hors ligne',
    cacheCleared: 'Cache vidé, actualisation des données...',
    updateReady: 'Mise à jour prête à être installée',
    updateInstalling: 'Installation de la mise à jour...',
    updateError: 'Erreur de mise à jour',
    offlineMessage: 'Vous devez être en ligne pour utiliser cette application'
  },
  auth: {
    login: {
      title: 'Connexion',
      email: 'Email',
      password: 'Mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      submit: 'Se connecter',
      googleButton: 'Continuer avec Google',
      noAccount: "Vous n'avez pas de compte ?",
      signupLink: "S'inscrire",
      invalidCredentials: "Email ou mot de passe incorrect",
      googleError: "Erreur lors de la connexion avec Google. Veuillez réessayer."
    },
    signup: {
      title: 'Inscription',
      email: 'Email',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      terms: "J'ai lu et j'accepte les conditions d'utilisation",
      privacyPolicy: "Politique de confidentialité",
      submit: "S'inscrire",
      googleButton: 'Continuer avec Google',
      hasAccount: 'Vous avez déjà un compte ?',
      loginLink: 'Se connecter',
      signupError: "Erreur lors de l'inscription. Cet email est peut-être déjà utilisé.",
      googleError: "Erreur lors de l'inscription avec Google. Veuillez réessayer.",
      emailVerification: {
        title: "Vérifiez votre email",
        message: "Un email de confirmation a été envoyé à {{email}}. Veuillez cliquer sur le lien dans l'email pour finaliser votre inscription.",
        resend: "Renvoyer l'email",
        resendSuccess: "Email de confirmation renvoyé !",
        resendError: "Erreur lors de l'envoi de l'email. Veuillez réessayer."
      }
    },
    forgotPassword: {
      title: 'Mot de passe oublié',
      email: 'Email',
      submit: 'Réinitialiser le mot de passe',
      backToLogin: 'Retour à la connexion',
      instructions: 'Entrez votre adresse email pour recevoir un lien de réinitialisation.',
      resetLinkError: 'Erreur lors de l\'envoi du lien de réinitialisation. Veuillez réessayer.',
      emailSentTitle: 'Email envoyé !',
      emailSentMessage: 'Vérifiez votre boîte de réception et suivez les instructions pour réinitialiser votre mot de passe.'
    },
    validation: {
      emailRequired: "L'email est requis",
      emailInvalid: "L'email n'est pas valide",
      passwordRequired: 'Le mot de passe est requis',
      passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      termsRequired: "Vous devez accepter les conditions d'utilisation"
    },
    resetPassword: {
      title: 'Réinitialiser le mot de passe',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      submit: 'Réinitialiser',
      error: 'Une erreur est survenue lors de la réinitialisation du mot de passe',
      success: 'Votre mot de passe a été réinitialisé avec succès'
    }
  },
  home: {
    title: 'Recherche de couples',
    subtitle: 'Informez-vous en continu, aimez en toute tranquillité',
    uploadPhoto: {
      title: 'Ajoutons la photo ici',
      subtitle: 'Le visage doit être clairement visible',
      change: 'Cliquez pour changer la photo'
    },
    additionalInfo: {
      title: '',
      fullName: 'Nom complet',
      phone: 'Téléphone',
      country: 'Pays',
      city: 'Ville',
      addNumber: 'Ajouter un numéro'
    },
    search: 'Rechercher',
    searching: 'Recherche en cours...',
    searchNote: 'Note : {error}. La recherche textuelle sera quand même effectuée.',
    noResults: 'Aucun résultat trouvé pour votre recherche',
    singleSearch: 'Recherche célibataire',
    crawlText: {
      part1: 'Ajoutez vos relations',
      part2: '',
      part3: ' sur votre profil et ',
      part4: 'informez-vous chaque semaine',
      part5: 'une autre personne sort avec votre partenaire',
      part6: ' sur cette page pour savoir si ',
      part7: ', donc si une autre personne l\'a aussi ajoutée sur son profil'
    },
    results: {
      title: 'Résultats',
      certified: 'Certifiée',
      pending: 'Certification',
      createdBy: 'Relation créée ou certifiée par',
      createdOrCertifiedBy: 'Relation créée par/Relation certifiée par',
      contact: 'Contact',
      match: 'correspondance',
      unlockMessage: 'Déverrouillez pour voir les détails',
      unlockDetailedMessage: 'Déverrouillez et savoir avec qui cette personne est en couple ou mariée',
      unlockTitle: 'Déverrouillage !',
      unlockDescription: 'Savoir avec qui cette personne est en couple ou mariée',
      count: '{{count}} résultats trouvés',
      viewAll: 'Voir tout',
      allResults: 'Tous les résultats ({{count}})',
      viewDetails: 'Voir les détails'
    },
    login: {
      message: 'Connectez-vous pour voir les résultats et savoir avec qui cette personne est en couple ou mariée',
      required: 'Connexion requise'
    },
    addRelationPrompt: 'Ajoutez vos relations sur votre profil et recevez des alertes !',
    loginFullPrompt: 'Ajoutez vos relations sur votre profil et recevez des alertes !',
    unlock: {
      confirmTitle: 'Déverrouiller les détails',
      confirmMessage: 'Êtes-vous sûr de vouloir savoir avec qui cette personne est en couple ou mariée ?',
      cost: 'Coût : {{price}}',
      donation: 'Coût : {{price}}',
      action: 'Déverrouiller',
      waitingDonation: 'En attente de paiement...',
      remainingTime: 'Temps restant : {{minutes}}:{{seconds}}',
      thankYou: 'Merci!'
    },
    infoPopup: {
      message: "Vérifiez si votre relation que vous avez ajoutée sur votre profil est en couple avec une autre personne, entrez ses informations ici",
      close: "Fermer"
    }
  },
  profile: {
    back: 'Retour',
    homepage: 'Page d\'accueil',
    myNumber: 'Mon num',
    description: 'Vous pouvez mettre un lien ici',
    addRelationPopup: {
      message: "Vous êtes en couple? Ajoutez vos relations et sécurisez-les",
      close: "Fermer"
    },
    backButtonPopup: {
      message: "Parfait ! Vérifiez si votre relation est en couple avec une autre personne, sur la page d'accueil",
      close: "Fermer"
    },
    notifications: {
      title: 'Notifications',
      markAllAsRead: 'Tout marquer comme lu',
      deleteAll: 'Tout effacer',
      empty: 'Aucune notification',
      timeFormat: {
        days: 'j',
        hours: 'h',
        minutes: 'm',
        now: 'maintenant'
      },
      messages: {
        relationSearched: 'Un utilisateur a recherché "{{name}}" et l\'a trouvé dans ses résultats.',
        relationConfirmed: '{{name}} a certifié votre relation.',
        relationRejected: '{{name}} a rejeté votre relation.',
        relationDeleted: '{{name}} a supprimé votre relation.'
      },
      titles: {
        relationSearched: 'Votre relation a été recherchée',
        relationConfirmed: 'Relation certifiée',
        relationRejected: 'Relation rejetée',
        relationDeleted: 'Relation supprimée'
      }
    },
    relations: {
      title: 'Mes relations',
      add: 'Ajouter',
      certifiedBy: 'Certifié par {{name}}',
      unknown: 'Nom inconnu',
      status: {
        couple: 'couple',
        en_couple: 'en couple',
        married: 'marié(e)',
        ex: 'ex',
        date: 'en rendez-vous'
      },
      confirmation: {
        pending: 'Certification',
        confirmed: 'Certifiée',
        rejected: 'Rejetée'
      },
      share: 'Partager',
      copied: 'Copié',
      shareHint: 'Partagez cette relation pour la faire certifier',
      deleteConfirm: {
        certified: "Êtes-vous sûr de vouloir supprimer cette relation ? Cette action supprimera également la relation chez l'autre utilisateur.",
        uncertified: "Êtes-vous sûr de vouloir supprimer cette relation ?"
      },
      deleteError: "Erreur lors de la suppression de la relation",
      deleteFailed: "La suppression a échoué. Veuillez réessayer.",
      deleteImpossible: "Impossible de supprimer la relation. Veuillez réessayer.",
      copyLink: 'Copier le lien de partage',
      mirror: 'Miroir',
      noName: 'Sans nom',
      createdBy: 'Créée par {{name}}'
    },
    addRelation: {
      title: 'Nouvelle relation',
      editTitle: 'Modifier la relation',
      form: {
        photo: {
          add: 'Ajoutez une photo',
          change: 'Changer la photo',
          hint: 'Le visage doit être clairement visible'
        },
        name: 'Nom complet',
        phone: 'Téléphone',
        addPhone: 'Ajouter un numéro',
        country: 'Pays',
        city: 'Ville',
        status: 'Statut',
        submit: 'Ajouter la relation',
        update: 'Modifier la relation',
        saving: 'Enregistrement...',
        updating: 'Mise à jour...',
        comment: 'Commentaire (optionnel)'
      }
    },
    userProfile: {
      defaultName: "Utilisateur",
      defaultLink: "Mon Contact",
      defaultDescription: "Parlez de vous en quelques mots",
      editName: {
        placeholder: "Entrez votre nom"
      },
      editLink: {
        textPlaceholder: "Entrez votre description",
        urlPlaceholder: "Entrez l'URL (optionnel)"
      },
      nameSaved: "Nom sauvegardé !",
      linkSaved: "Lien sauvegardé !",
      contactCopied: "Contact copié !"
    },
    help: {
      tips: 'Bon à savoir',
      privacy: "Politique de confidentialité et termes d'utilisation",
      contact: 'Contactez-nous',
      support: 'Soutenir',
      tipsTitle: "Conseils et astuces",
      contactTitle: "Besoin d'aide ?"
    },
    deleteRelation: {
      title: 'Mettre fin à la relation',
      confirmation: 'Êtes-vous sûr de vouloir mettre fin à votre relation avec {{name}} ?',
      confirm: 'Mettre fin',
      cost: 'Coût de suppression : {{price}}',
      donation: 'Coût de suppression : {{price}}',
      waitingDonation: 'En attente de paiement...',
      thankYou: 'Merci!',
      continueDonation: 'Finaliser le paiement'
    },
    shareRelation: {
      title: 'Prévisualisation',
      copyLink: 'Copier le lien de partage',
      copyPhone: 'Copier le numéro'
    },
    datingProfile: {
      title: '',
      country: 'Pays',
      countryPlaceholder: 'Votre pays',
      city: 'Ville',
      cityPlaceholder: 'Votre ville',
      gender: 'Sexe',
      genderOption: {
        select: 'Sélectionnez',
        male: 'Homme',
        female: 'Femme',
        other: 'Autre'
      },
      age: 'Âge',
      agePlaceholder: 'Votre âge',
      relationType: 'Type de relation que vous recherchez',
      relationTypes: {
        shortTerm: 'Court terme',
        longTerm: 'Long terme',
        short: 'Courte',
        long: 'Longue'
      },
      shortTermIntentions: 'Intentions (Court terme)',
      longTermIntentions: 'Intentions (Long terme)',
      moneyAmount: 'C\'est combien ?',
      moneyPlaceholder: 'Montant',
      moneyFlow: {
        give: 'Donner',
        receive: 'Recevoir'
      },
      hookup: 'Conclure',
      resto: 'Resto',
      drink: 'Prendre un verre',
      seeWhat: 'On verra',
      other: 'Autres',
      marriage: 'Mariage',
      children: 'Enfants',
      fidelity: 'Fidélité',
      polygamy: 'Polygamie',
      free: 'Libre',
      photos: 'Photos (Maximum 4)',
      visibility: 'Visibilité dans les recherches',
      activateVisibility: 'Activer la visibilité',
      contactClicks: 'Clics sur votre contact',
      contactClicksInfo: 'Ce bouton se met automatiquement en "OFF" après 5 clics sur votre lien de contact, et votre profil sera automatiquement masqué dans les résultats de recherches célibataires. Vous pourrez le réactiver manuellement à tout moment en le remettant sur "ON" et en sauvegardant vos préférences. Le compteur continue à partir du dernier nombre de clics enregistrés.',
      orientation: {
        title: 'Orientation sexuelle',
        hetero: 'Hétérosexuel',
        gay: 'Gay',
        lesbian: 'Lesbienne',
        bi: 'Bisexuel'
      }
    },
    referral: {
      code: 'Code de parrainage',
      codePlaceholder: 'Entrez un code de parrainage',
      codeApplied: 'Code de parrainage appliqué avec succès',
      codeInfo: 'Entrez un code de parrainage si vous en avez un'
    }
  },
  settings: {
    title: 'Paramètres',
    unsavedChangesTitle: 'Modifications non enregistrées',
    unsavedChangesMessage: 'Vous avez des modifications non enregistrées. Si vous quittez cette page, toutes vos modifications seront perdues.',
    stayOnPage: 'Rester sur la page',
    leaveAnyway: 'Quitter quand même',
    unsavedChanges: 'Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter sans enregistrer ?',
    saveSuccess: 'Préférences enregistrées ✓',
    saveChanges: 'Enregistrer les modifications',
    save: 'Enregistrer mes préférences',
    saving: 'En cours...',
    crawlText: 'Complétez votre profil pour être visible dans les recherches célibataires.',
    photo: {
      title: 'Photo de profil',
      description: 'Téléchargez une photo de vous qui montre clairement votre visage'
    },
    name: {
      title: "Nom d'utilisateur",
      description: 'Les autres utilisateurs vous verront sous ce nom'
    },
    description: {
      title: "Description",
      placeholder: "Parlez de vous en quelques mots (500 caractères max)",
      charCount: "{{current}}/500 caractères"
    },
    link: {
      title: 'Lien de contact ou téléphone',
      description: 'Ajoutez un lien vers vos réseaux sociaux ou vos coordonnées',
      placeholder: 'Aucun lien ajouté',
      hint: 'Entrez un numéro de téléphone ou un lien web (URL). Formats acceptés: +123456789 ou https://...'
    },
    password: {
      title: 'Changer de mot de passe ?',
      description: 'Modifiez votre mot de passe pour sécuriser votre compte',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmez le mot de passe',
      success: 'Votre mot de passe a été modifié avec succès',
      showPassword: 'Afficher le mot de passe',
      hidePassword: 'Masquer le mot de passe',
      error: {
        mismatch: 'Les mots de passe ne correspondent pas',
        tooShort: 'Le mot de passe doit contenir au moins 6 caractères',
        updateFailed: 'La modification du mot de passe a échoué',
        currentPasswordIncorrect: 'Le mot de passe actuel est incorrect',
        userNotFound: 'Utilisateur non trouvé'
      }
    },
    datingProfile: {
      title: ''
    },
    changePhoto: 'Changer la photo',
    customLink: 'Nom du lien personnalisé',
    customLinkPlaceholder: 'mon-lien',
    customLinkUrl: 'URL du lien',
    logout: 'Se déconnecter',
    deleteAccount: 'Supprimer le compte',
    privacyPolicyButton: 'Politique de Confidentialité et Conditions Générales d\'Utilisation',
    settingsTitle: "Paramètres administrateur",
    featurePricing: "Prix des fonctionnalités",
    relationDeletionPrice: "Prix pour supprimer une relation",
    relationUnlockPrice: "Prix pour déverrouiller les détails d'une relation",
    shortTermSearchUnlockPrice: "Prix pour déverrouiller les résultats de relations court terme dans la recherche",
    amount: "Montant",
    currency: "Devise",
    enabled: "Activé",
    paymentGateway: "Passerelle de paiement",
    gateways: "Passerelles",
    alternativeUrl: "URL alternative",
    alternativeUrlDescription: "URL vers laquelle rediriger les utilisateurs pour le paiement (utilisez $bodycount comme variable)",
    mobilePaymentNumbers: "Numéros de paiement mobile",
    orangeMoney: "Orange Money",
    mtnMoney: "MTN Money",
    add: "Ajouter",
    noNumbersConfigured: "Aucun numéro configuré",
    number: "Numéro",
    reference: "Référence",
    helpButton: "Bouton d'aide",
    animation: "Animation",
    helpButtonDescription: "Activer/désactiver l'animation du bouton d'aide",
    helpResources: "Ressources d'aide",
    tips: "Conseils",
    contact: "Contact",
    don: "Don",
    privacyPolicy: "Politique de confidentialité",
    termsOfService: "Conditions générales",
    editResource: "Modifier la ressource",
    newResource: "Nouvelle ressource",
    type: "Type",
    status: "Statut",
    resourceTitle: "Titre",
    resourceLink: "Lien",
    resourceDesc: "Description",
    enterDescription: "Entrez une description",
    cancelAction: "Annuler",
    saveResource: "Enregistrer",
    savingResource: "Enregistrement...",
    saveAll: "Tout enregistrer",
    modified: "Modifié le",
    validatePayment: "Valider le paiement",
    validating: "Validation...",
    paymentValidated: "Paiement validé",
    paymentHistory: "Historique des paiements"
  },
  share: {
    title: 'dit être {{status}} avec vous',
    question: 'Certifiez-vous cette relation ?',
    confirm: 'Je certifie !',
    reject: 'Je refuse !',
    backToHome: 'Retour à l\'accueil',
    backToProfile: 'Retour au profil',
    congratulations: 'Heureuse et longue relation à vous',
    creatorMessage: "C'est ce que verra la personne concernée. Copiez le lien et envoyez-le pour certifier votre relation.",
    linkCopied: 'Lien copié !',
    copyLink: 'Copier le lien',
    loginMessage: 'Connectez-vous pour refuser ou certifier cette relation.',
    relationCertified: 'Relation certifiée !',
    relationRejected: 'Relation refusée',
    redirecting: 'Redirection vers votre profil...',
    creatorAlt: 'Créateur de la relation',
    targetAlt: 'Personne concernée',
    auth: {
      signup: {
        title: "Vous n'êtes pas inscrit ?",
        button: 'Inscription',
        description: 'Inscrivez-vous à MyCount pour certifier la relation'
      },
      login: {
        title: 'Vous êtes déjà inscrit ?',
        button: 'Connexion',
        description: 'Connectez-vous à MyCount pour certifier la relation'
      }
    },
    errors: {
      relationNotFound: "Relation non trouvée dans la base de données",
      loadingError: "Une erreur est survenue lors du chargement de la relation",
      certificationError: "Une erreur s'est produite lors de la certification",
      rejectionError: "Une erreur s'est produite lors du rejet"
    }
  },
  imageCropper: {
    title: "Recadrer l'image",
    subtitle: "Positionnez le cadre pour que le visage soit bien visible",
    cancel: "Annuler",
    validate: "Valider",
    preview: "Aperçu"
  },
  notifications: {
    title: 'Notifications',
    markAllAsRead: 'Tout marquer comme lu',
    deleteAll: 'Tout effacer',
    empty: 'Aucune notification',
    timeFormat: {
      days: 'j',
      hours: 'h',
      minutes: 'm',
      now: 'maintenant'
    },
    messages: {
      relationSearched: 'Un utilisateur a recherché "{{name}}" et l\'a trouvé dans ses résultats.',
      relationConfirmed: '{{name}} a certifié votre relation.',
      relationRejected: '{{name}} a rejeté votre relation.',
      relationDeleted: '{{name}} a supprimé votre relation.'
    },
    titles: {
      relationSearched: 'Votre relation a été recherchée',
      relationConfirmed: 'Relation certifiée',
      relationRejected: 'Relation rejetée',
      relationDeleted: 'Relation supprimée'
    },
    new_relation: {
      title: "Nouvelle relation",
      message: "{{userName}} a créé une nouvelle relation avec {{targetName}}."
    },
    relation_confirmed: {
      title: "Relation confirmée",
      message: "{{targetName}} a confirmé votre relation."
    },
    relation_rejected: {
      title: "Relation rejetée",
      message: "{{targetName}} a rejeté votre relation."
    },
    relation_deleted: {
      title: "Relation supprimée",
      message: "{{targetName}} a supprimé votre relation."
    },
    relationConfirmed: {
      title: "Relation certifiée",
      message: "{{name}} a certifié votre relation."
    },
    search_result: {
      title: "Résultat de recherche",
      message: "Nous avons trouvé {{count}} correspondance(s) pour votre recherche."
    },
    search_found: {
      title: "Votre relation a été trouvée",
      message: "Un utilisateur a recherché {{targetName}} et l'a trouvé dans ses résultats."
    },
    relationSearchedByUser: {
      title: "Votre relation a été recherchée",
      message: "{{user}} a recherché \"{{name}}\" et l'a trouvé dans ses résultats."
    },
    relationSearched: {
      title: "Votre relation a été recherchée",
      message: "Un utilisateur a recherché \"{{name}}\" et l'a trouvé dans ses résultats."
    },
    relationDeletedByCreator: {
      title: 'Relation supprimée',
      message: '{{user}} a supprimé la relation avec {{name}}.'
    },
    relationDeletedByCertified: {
      title: 'Relation supprimée',
      message: '{{user}} a supprimé la relation avec {{name}}.'
    },
    permission: {
      title: "Activer les notifications",
      description: "Recevez des notifications pour rester informé des activités importantes.",
      accept: "Activer",
      decline: "Non merci"
    }
  },
  payment: {
    back: 'Retour',
    deleteTitle: 'Paiement pour la suppression',
    unlockTitle: 'Paiement pour le déverrouillage',
    pay: 'Payer maintenant',
    processing: 'Traitement en cours...',
    validating: 'Validation du paiement...',
    finalizing: 'Finalisation du paiement...',
    waitingMobile: 'En attente de votre confirmation sur votre téléphone...',
    success: 'Paiement réussi !',
    failed: 'Le paiement a échoué',
    invalidCallback: 'La validation du paiement a échoué',
    fillAllFields: 'Veuillez remplir tous les champs',
    genericError: 'Une erreur est survenue lors du paiement',
    
    // Mobile Money
    mobileNumber: 'Numéro de téléphone mobile',
    mobileNumberHint: 'Entrez le numéro associé à votre compte Mobile Money',
    initiate: 'Initier le paiement',
    mobileMoneyInitiated: 'Demande de paiement initiée',
    waitingForPayment: 'En attente de votre paiement',
    checkYourPhone: 'Veuillez vérifier votre téléphone pour confirmer le paiement',
    followInstructions: 'Suivez les instructions sur votre téléphone pour compléter le paiement',
    cancel: 'Annuler le paiement',
    
    services: {
      shortTermUnlock: 'Déverrouiller les rencontres court terme',
      relationDeletion: 'Supprimer la relation',
      searchDetailsUnlock: 'Déverrouiller les détails de recherche'
    },
    
    mobile: {
      fullName: 'Nom complet',
      phoneNumber: 'Numéro de téléphone',
      phoneFormat: 'Format: +237XXXXXXXXX',
      instructions: 'Instructions de paiement',
      checkPhone: 'Vérifiez votre téléphone pour valider le paiement',
      waitingMobile: 'En attente de votre confirmation sur le téléphone...',
      zones: {
        xaf: 'Zone FCFA (Afrique Centrale)',
        xof: 'Zone FCFA (Afrique de l\'Ouest)',
        cdf: 'Franc Congolais (RDC)'
      },
      providers: {
        orange_cm: 'Orange Cameroun',
        mtn_cm: 'MTN Cameroun',
        orange_ga: 'Orange Gabon',
        airtel_ga: 'Airtel Gabon',
        orange_cg: 'Orange Congo',
        mtn_cg: 'MTN Congo',
        orange_cf: 'Orange Centrafrique',
        orange_td: 'Orange Tchad',
        orange_sn: 'Orange Sénégal',
        free_sn: 'Free Sénégal',
        wave_sn: 'Wave Sénégal',
        moov_bj: 'Moov Bénin',
        mtn_bj: 'MTN Bénin',
        orange_ci: 'Orange Côte d\'Ivoire',
        mtn_ci: 'MTN Côte d\'Ivoire',
        moov_ci: 'Moov Côte d\'Ivoire',
        orange_ml: 'Orange Mali',
        moov_tg: 'Moov Togo',
        tmoney_tg: 'T-Money Togo',
        orange_cd: 'Orange RDC',
        airtel_cd: 'Airtel RDC',
        mpesa_cd: 'M-Pesa RDC'
      }
    },
    card: {
      cvvInfo: 'Le code CVV est le code à 3 chiffres au dos de votre carte',
      nameInfo: 'Le nom doit correspondre exactement à celui inscrit sur votre carte'
    },
    
    // Payment Flow
    title: 'Workflow de Paiement Simple (Mobile Money)',
    stepOne: 'Choix de l\'option premium',
    stepTwo: 'Sélection du mode de paiement',
    userClicks: 'L\'utilisateur clique sur un bouton :',
    userSees: 'Il voit le',
    amount: 'Montant',
    andThe: 'et les',
    paymentMethods: 'modes de paiement',
    available: 'disponibles',
    activate: 'Activer',
    unlock: 'Débloquer',
    payButton: 'Payer',
    continue: 'Continuer',
    proceed: 'Procéder au paiement',
    orangeMoney: 'Orange Money',
    mtnMoney: 'MTN Mobile Money',
    manualTransfer: 'Informations pour le transfert manuel',
    manualInstructions: 'Tu fournis les informations pour le transfert manuel :',
    example: 'Exemple :',
    sendAmount: 'Envoyez',
    to: 'à',
    reference: 'Référence',
    manualTransferNote: 'Après avoir effectué le transfert, <span class="text-yellow-400">copiez l\'ID de transaction que vous avez reçu</span>, collez-le sur le champ de saisie en bas, et cliquez sur \'J\'ai payé\' pour confirmer votre paiement.',
    transactionId: 'ID de transaction',
    transactionIdPlaceholder: 'Entrez l\'ID de votre transaction',
    verify: 'J\'ai payé',
    processingPayment: 'Traitement...'
  },
  common: {
    or: "ou",
    cancel: "Annuler",
    confirm: 'Confirmer',
    customerService: "Service client",
    profile: "Profil",
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    delete: "Supprimer",
    deleting: "Suppression...",
    unexpectedError: "Une erreur inattendue s'est produite",
    offlineMode: "Mode hors ligne",
    offlineDataAvailable: "Données disponibles hors ligne",
    offlineFeature: "Non disponible hors ligne",
    offlineSearchDisabled: "La recherche n'est pas disponible en mode hors ligne",
    later: "Plus tard",
    login: "Se connecter",
    search: "Rechercher",
    seeMore: "Voir plus",
    seeLess: "Voir moins",
    back: 'Retour',
    edit: 'Modifier',
    settings: 'Paramètres',
    save: 'Enregistrer',
    saveAll: 'Tout enregistrer',
    saving: 'Enregistrement...',
    close: 'Fermer',
    send: 'Envoyer',
    add: 'Ajouter',
    logout: 'Déconnexion',
    signup: 'S\'inscrire',
    comingSoon: 'Fonctionnalité à venir',
    refresh: "Actualiser"
  },
  update: {
    newVersion: 'Nouvelle version disponible',
    description: 'Une nouvelle version de l\'application est disponible. Installez-la pour bénéficier des dernières fonctionnalités et corrections.',
    install: 'Installer',
    installAndReload: 'Installer et redémarrer',
    downloading: 'Téléchargement de la mise à jour...',
    preparing: 'Préparation de l\'installation...',
    restarting: 'Redémarrage de l\'application...'
  },
  singleSearch: {
    title: 'Recherche célibataire',
    subtitle: 'Trouvez votre prochain crush',
    crawlText: {
      part1: 'Enregistrez',
      part2: '',
      part3: ' vos coordonnées, dans les paramètres de ',
      part4: 'votre profil',
      part5: '',
      part6: ', pour être trouvé ici.',
      part7: ''
    },
    photoCarousel: {
      title: '',
      loading: 'Chargement des photos...',
      error: 'Impossible de charger les photos',
      emptyState: 'Aucune photo disponible pour le moment'
    },
    form: {
      country: 'Pays',
      city: 'Ville',
      ageRange: 'Tranche d\'âge',
      gender: 'Sexe',
      ageRanges: {
        '18-25': '18-25 ans',
        '26-35': '26-35 ans',
        '36-45': '36-45 ans',
        '46-55': '46-55 ans',
        '56+': '56+ ans'
      },
      genderOptions: {
        homme: 'Homme',
        femme: 'Femme'
      },
      search: 'Rechercher',
      searching: 'Recherche en cours...'
    },
    results: {
      searching: 'Recherche en cours...',
      found: '{{count}} résultat{{plural}} trouvé{{plural}}',
      notFound: 'Aucun résultat trouvé',
      searchingMessage: 'Recherche de célibataires...',
      tryModify: 'Essayez de modifier vos critères de recherche',
      longTerm: 'Long terme',
      shortTerm: 'Court terme',
      age: 'ans',
      photos: 'photos',
      foundSimple: 'trouvé{{plural}}'
    },
    gallery: {
      photo: 'Photo {{current}} de {{total}}',
      of: 'de',
      swipeToNavigate: 'Balayez pour naviguer'
    },
    intentions: {
      hookup: 'Conclure',
      resto: 'Resto',
      drink: 'Prendre un verre',
      seeWhat: 'On verra',
      other: 'Autres',
      marriage: 'Mariage',
      children: 'Enfants',
      fidelity: 'Fidélité',
      polygamy: 'Polygamie',
      free: 'Libre'
    },
    payment: {
      title: 'Déverrouiller les résultats',
      message: 'Pour voir les résultats court terme, un paiement est nécessaire.'
    },
    loginPrompt: 'Connectez-vous pour trouver les célibataires de votre ville',
    crushLimitPopup: {
      title: 'Limite atteinte',
      message: 'Vous ne pouvez ajouter que 3 crushes par recherche. Pour ajouter plus de crushes, effectuez une nouvelle recherche.',
      close: 'Fermer'
    },
    hide: 'Masquer'
  },
  myCrush: {
    title: 'My Crush',
    subtitle: '',
    loading: 'Chargement de vos crushs...',
    empty: {
      title: 'Aucun crush pour le moment',
      message: 'Utilisez le bouton cœur sur les profils qui vous intéressent pour les retrouver ici.',
      action: 'Commencer la recherche'
    },
    count: {
      single: 'Vous avez {{count}} crush',
      plural: 'Vous avez {{count}} crushs'
    },
    relation: {
      shortTerm: 'Relation court terme',
      longTerm: 'Relation long terme'
    },
    deleteSuccess: 'Profil retiré de vos crushs',
    deleteError: 'Erreur lors de la suppression',
    expirationInfo: 'Les crushs expirent automatiquement après 7 jours',
    expiresIn: 'Expire',
    refresh: 'Actualiser',
    refreshSuccess: 'Liste actualisée'
  },
  thankYou: 'Merci pour votre contribution !',
  privacyPolicy: {
    title: 'Politique de Confidentialité',
    termsTitle: 'Conditions Générales d\'Utilisation',
    loading: 'Chargement du contenu...',
    errorLoading: 'Erreur lors du chargement du contenu. Veuillez réessayer plus tard.'
  },
  admin: {
    accessDenied: {
      title: "Accès refusé",
      message: "Vous n'avez pas les autorisations nécessaires pour accéder à cette page.",
      returnHome: "Retour à l'accueil"
    },
    dashboard: {
      title: "Administration",
      roleLabel: "Rôle",
      returnToApp: "Retour à l'application",
      statsTitle: "Statistiques",
      sectionsTitle: "Sections",
      noStats: "Aucune statistique disponible",
      noAccessibleSections: "Aucune section accessible",
      manageSection: "Gérer",
      errorFetchingStats: "Erreur lors de la récupération des statistiques",
      returnToDashboard: "Retour au tableau de bord",
      sections: {
        users: "Utilisateurs",
        relations: "Relations",
        payments: "Paiements",
        settings: "Paramètres"
      },
      stats: {
        users: "Utilisateurs",
        relations: "Relations",
        payments: "Paiements",
        activeUsers: "Utilisateurs actifs",
        certifiedRelations: "Relations certifiées"
      },
      sectionDescriptions: {
        users: "Gérer les utilisateurs et leurs autorisations",
        relations: "Gérer les relations et les certifications",
        payments: "Suivre les transactions et les paiements",
        settings: "Configurer les paramètres de l'application"
      },
      profile: {
        title: "Mon profil",
        fullName: "Nom complet",
        mobileMoneyNumber: "Numéro Mobile Money",
        save: "Enregistrer",
        saving: "Enregistrement...",
        saved: "Enregistré",
        validatePayment: "Valider le paiement",
        validating: "Validation...",
        paymentValidated: "Paiement validé",
        paymentHistory: "Historique des paiements",
        totalPayments: "Total reçu",
        since: "Depuis",
        lastPayment: "Dernier paiement reçu",
        noPayments: "Aucun paiement reçu",
        adminInfo: "Informations de l'admin",
        paymentStatus: "Statut de paiement",
        pending: "En attente",
        validated: "Validé",
        paymentSuccessMessage: "Paiement validé avec succès",
        noPermissionToValidate: "Seul un super admin peut valider les paiements"
      }
    },
    header: {
      admin: "Admin",
      adminArea: "Espace administrateur",
      becomeAdmin: "Devenez admin, faites inscrire d'autres utilisateurs et gagnez de l'argent à vie",
      contactUs: "Contactez-nous"
    },
    settings: {
      title: "Paramètres administrateur",
      featurePricing: "Prix des fonctionnalités",
      relationDeletionPrice: "Prix pour supprimer une relation",
      relationUnlockPrice: "Prix pour déverrouiller les détails d'une relation",
      shortTermSearchUnlockPrice: "Prix pour déverrouiller les résultats de relations court terme dans la recherche",
      amount: "Montant",
      currency: "Devise",
      enabled: "Activé",
      paymentGateway: "Passerelle de paiement",
      gateways: "Passerelles",
      alternativeUrl: "URL alternative",
      alternativeUrlDescription: "URL vers laquelle rediriger les utilisateurs pour le paiement (utilisez $bodycount comme variable)",
      mobilePaymentNumbers: "Numéros de paiement mobile",
      orangeMoney: "Orange Money",
      mtnMoney: "MTN Money",
      add: "Ajouter",
      noNumbersConfigured: "Aucun numéro configuré",
      number: "Numéro",
      reference: "Référence",
      helpButton: "Bouton d'aide",
      animation: "Animation",
      helpButtonDescription: "Activer/désactiver l'animation du bouton d'aide",
      helpResources: "Ressources d'aide",
      tips: "Conseils",
      contact: "Contact",
      don: "Don",
      privacyPolicy: "Politique de confidentialité",
      termsOfService: "Conditions générales",
      editResource: "Modifier la ressource",
      newResource: "Nouvelle ressource",
      type: "Type",
      status: "Statut",
      resourceTitle: "Titre",
      link: "Lien",
      description: "Description",
      enterDescription: "Entrez une description",
      cancel: "Annuler",
      save: "Enregistrer",
      saving: "Enregistrement...",
      saveAll: "Tout enregistrer",
      modified: "Modifié le"
    }
  },
  signupFlow: {
    title: 'Configurez votre profil',
    subtitle: 'MyCount est une web-appli de rencontre et de gestion de relations',
    stepSubtitles: {
      1: 'MyCount est une web-appli de rencontre et de gestion de relations',
      2: "Trouvez l'Amour ou l'amour, directement sur MyCount",
      3: 'Les intentions de rencontres sont claires et le contact est direct. Pas de perte de temps ou de message inutile.',
      4: 'Vous serez contacté directement par ce contact',
      5: 'MyCount s\'adresse à tous ceux qui veulent du direct, du concret et du vrai',
      6: 'Une liberté et nouvelle façon de faire des rencontres'
    },
    prevStep: 'Précédent',
    nextStep: 'Suivant',
    finish: 'Terminer',
    error: {
      savingProfile: 'Une erreur est survenue lors de la sauvegarde de votre profil. Veuillez réessayer.'
    },
    step1: {
      title: "Votre identité",
      subtitle: "Aidez-nous à vous connaître",
      fullName: "Nom complet",
      fullNamePlaceholder: "Entrez votre nom complet",
      language: "Langue",
      languageOptions: {
        fr: "Français",
        en: "Anglais"
      },
      country: "Pays",
      countryPlaceholder: "Sélectionnez votre pays",
      city: "Ville",
      cityPlaceholder: "Entrez votre ville"
    },
    step2: {
      title: 'Votre profil',
      subtitle: 'Trouvez l\'Amour ou l\'amour, directement sur MyCount',
      gender: 'Genre',
      genderOptions: {
        man: 'Homme',
        woman: 'Femme'
      },
      birthDate: 'Date de naissance',
      birthDatePlaceholder: 'Sélectionnez votre date de naissance',
      sexuality: 'Orientation sexuelle',
      sexualityOptions: {
        hetero: 'Hétérosexuel',
        gay: 'Gay',
        lesbian: 'Lesbienne',
        bisexual: 'Bisexuel(le)',
        bi: 'Bisexuel(le)'
      },
      relationType: 'Type de relation recherchée',
      shortTerm: "Relations à court terme",
      longTerm: "Relations à long terme",
      stShort: "Court terme",
      ltShort: "Long terme",
      shortIntentionCheck: "Je recherche des relations à court terme",
      longIntentionCheck: "Je recherche des relations à long terme",
    },
    step3: {
      title: 'Type de relation',
      relationType: 'Quel type de relation recherchez-vous ?',
      youSearch: 'Vous recherchez ?',
      shortTerm: 'Court terme',
      longTerm: 'Long terme',
      shortTermIntentions: 'Intentions à court terme',
      longTermIntentions: 'Intentions à long terme',
      money: 'Budget (optionnel)',
      moneyPlaceholder: 'Entrez un montant',
      moneyFlow: 'Qui paie ?',
      selectMoneyFlow: 'Sélectionnez qui paie',
      iReceive: 'Je reçois',
      iPay: 'Je paie',
      intentions: 'Vos intentions',
      hookup: 'Conclure',
      resto: 'Resto',
      drink: 'Prendre un verre',
      seeWhat: 'On verra bien',
      other: 'Autre',
      marriage: 'Mariage',
      children: 'Enfants',
      fidelity: 'Fidélité',
      polygamy: 'Polygamie',
      free: 'Libre'
    },
    step4: {
      title: 'Informations de contact',
      phone: 'Téléphone',
      phonePlaceholder: 'Entrez votre numéro de téléphone',
      contactLink: 'Lien de contact',
      contactLinkPlaceholder: 'Entrez votre lien de contact (Instagram, Telegram, etc.)'
    },
    step5: {
      title: 'Photos',
      description: 'Ajoutez au moins 2 photos de vous. La première photo sera votre photo de profil.',
      addPhoto: 'Ajouter une photo'
    },
    step6: {
      title: 'Visibilité dans les recherches'
    }
  }
};